import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../state'
import { Store } from '../store'

import * as item from './item'
@ngCore.Component({
  imports: [item.Component, ds.layout.divider.Component],
  selector: 'atn-navbar-app-list',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** @see {@link state.me.Feature} */
  public readonly meFeature = ngCore.inject(state.me.Feature)

  /** @see {@link state.admin.contexts.Feature} */
  public readonly adminContexts = ngCore.inject(state.admin.contexts.Feature)
  /** @see {@link state.navigation.Feature} */
  public readonly navigationFeature = ngCore.inject(state.navigation.Feature)

  /**
   * List of all apps that have at least one page.
   */
  public readonly appsSg = ngCore.computed(
    (
      apps = this.meFeature.contexts.selectors.availableApps.asSignal(),
      // TODO This is a temporary solution. We should show all apps even if they
      // have no pages. However, we need to create some landing page for empty
      // apps that has no pages assigned to them
    ) => apps.filter(app => app.pages.length > 0),
  )

  /** Whether the selected zone's app request has settled. */
  public readonly isAppsSettledSg = ngCore.computed(() => {
    const zoneId = this.meFeature.contexts.selectors.zoneId.asSignal()
    return zoneId
      ? this.meFeature.zoneApps.selectors.getResult(zoneId).asSignal().isSettled
      : false
  })

  /** Whether current user has Platform Admin access */
  public readonly isPlatformAdminSg = ngCore.computed(
    (currentUser = this.meFeature.selectors.currentUser.asSignal()) =>
      Boolean(currentUser?.isPlatformAdmin),
  )
}
